import React from "react";
import { motion } from "framer-motion";
import "./how-it-works.css";
import LazyBackground from "../../Lazy/lazy-background";

const HowItWorks = () => {
  const steps = [
    {
      icon: `${process.env.PUBLIC_URL}/assets/selecttest.svg`,
      title: "Select Your Test",
      description: "Browse our extensive catalog of genomics tests.",
    },
    {
      icon: `${process.env.PUBLIC_URL}/assets/placeorder.svg`,
      title: "Place Your Order",
      description: "Provide your information securely and complete the payment.",
    },
    {
      icon: `${process.env.PUBLIC_URL}/assets/samplecoll.svg`,
      title: "Sample Collection",
      description: "Get your sample delivered to us or visit our partner lab.",
    },
    {
      icon: `${process.env.PUBLIC_URL}/assets/accessres.svg`,
      title: "Access Results",
      description: "Get your results delivered securely to you.",
    },
  ];

  const sectionVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2, delayChildren: 0.1 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { type: "spring", stiffness: 100 } },
  };

  const imageVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.5, ease: "easeOut" } },
  };

  return (
    <section id="how-it-works" className="how-it-works-section">
        <LazyBackground
            src={`${process.env.PUBLIC_URL}/assets/background8.svg`}
            alt=""
            className="home-background home-background8"
            loading="lazy"
          />
      <div className="how-it-works-container">
        <motion.div
          className="how-it-works-content"
          variants={sectionVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <div className="how-it-works-left">
            <motion.h2 variants={itemVariants}>
              How it works: Simple, secure, seamless
            </motion.h2>
            <div className="steps-list">
              {steps.map((step, index) => (
                <motion.div key={index} className="step-item" variants={itemVariants}>
                  <div className="step-icon-wrapper">
                    <img src={step.icon} alt={`${step.title} icon`} className="step-icon" />
                  </div>
                  <div className="step-text">
                    <h3>{step.title}</h3>
                    <p>{step.description}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>

          <motion.div className="how-it-works-right" variants={imageVariants}>
            <img
              src={`${process.env.PUBLIC_URL}/assets/how-it-works-svg.svg`}
              alt="How it works illustration"
              className="how-it-works-main-image"
            />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default HowItWorks;